import React from "react";
import { connect } from "react-redux";

import { isDinnersReady } from "state/school_money/selectors";
import { markStudentDinnerBookingsAsSeen } from "state/school_money/actions";

import Preloader from "components/school_money/Preloader";
import MaintainValidStudentID from "components/school_money/MaintainValidStudentID";
import StudentSelector from "components/school_money/StudentSelector";
import StudentCarousel from "components/school_money/StudentCarousel";
import StudentDinnersList from "components/school_money/dinners/StudentDinnersList";

import "./DinnersPage.css";

class DinnersPage extends React.Component {

  generatePath(studentID) {
    return `/school_money/dinners/${studentID}/`;
  }

  isDinnersReady = (state) => {
    return isDinnersReady(state, this.props.studentID);
  }

  onStudentChange = (studentID, prevStudentID) => {
    this.props.markStudentDinnerBookingsAsSeen(prevStudentID);
    this.clearFocus();
  }

  componentWillUnmount() {
    this.props.markStudentDinnerBookingsAsSeen(this.props.match.params.studentID);
  }

  // ---------------------------------------------------------------------------
  // Clear focus is nescessary to turn off focus on dropdown menus when the
  // student is changed. At present changing the focus of the page to a div
  // element corrects this problem (IOS).
  // ---------------------------------------------------------------------------
  clearFocus() {

     // Get the first dinners-page element, should only be one.
     let dinnerPageElement = document.getElementsByClassName("dinners-page")[0];

     // Catch error when element is missing, do not continue;
     if(dinnerPageElement === undefined){return;}

     // To be able to focus on a div element we need to add a tabindex.
     dinnerPageElement.tabIndex = -1;
     dinnerPageElement.focus();
  }

  render() {
    const { studentID } = this.props.match.params;
    return (
      <MaintainValidStudentID currentStudentID={studentID} generatePath={this.generatePath}>
        <Preloader isPageReady={this.isDinnersReady}>
          <div className="dinners-page">
            <div className="page-header">
              <h1 className="page-header__title">Dinners</h1>
              <StudentSelector selectedStudentID={studentID} generatePath={this.generatePath} />
            </div>
            <StudentCarousel activeStudentID={studentID} generatePath={this.generatePath} onChange={this.onStudentChange}>
              { studentID => <StudentDinnersList key={studentID} studentID={studentID} /> }
            </StudentCarousel>
          </div>
        </Preloader>
      </MaintainValidStudentID>
    )
  }

}

export default connect(
  undefined,
  { markStudentDinnerBookingsAsSeen }
)(DinnersPage);



// WEBPACK FOOTER //
// ./src/components/school_money/dinners/DinnersPage.js